(() => {
  const SELECTOR = '[data-jd-marquee]';
  const instances = new WeakMap();

  class JDMarquee {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-jd-marquee-track]');
      this.group = root.querySelector('[data-jd-marquee-group]');
      this.ro = null;
      if (!this.track || !this.group) return;
      this.measure = this.measure.bind(this);
      this.bind();
      this.measure();
    }

    bind() {
      window.addEventListener('resize', this.measure, { passive: true });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.measure);
        this.ro.observe(this.group);
        this.ro.observe(this.root);
      }
    }

    measure() {
      const groupWidth = this.group.getBoundingClientRect().width;
      if (!groupWidth) return;
      this.root.style.setProperty('--jd-marquee-shift', `${groupWidth}px`);
    }

    destroy() {
      window.removeEventListener('resize', this.measure);
      this.ro?.disconnect();
    }
  }

  const mount = (scope = document) => {
    const roots = scope.matches?.(SELECTOR) ? [scope] : Array.from(scope.querySelectorAll?.(SELECTOR) || []);
    roots.forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new JDMarquee(root));
    });
  };

  const unmount = (scope) => {
    const root = scope.matches?.(SELECTOR) ? scope : scope.querySelector?.(SELECTOR);
    if (!root) return;
    instances.get(root)?.destroy();
    instances.delete(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount());
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
